import $ from 'jquery';
import gsap from 'gsap';

function initComponentsCollapseCardURLOpener() {
    //This grabs url query parameters
    $.urlParam = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)')
            .exec(window.location.search);

        return (results !== null) ? results[1] || 0 : false;
    }

    /*If we're provided a workshop id, open it up, and scroll to it*/
    if ($.urlParam('card') != false) {
        const urlParam = $.urlParam('card');
        $('#' + urlParam).collapse('show');
        $('html, body').animate({
            scrollTop: $("#" + urlParam).offset().top - 200
        }, 2000);
    }


    /*Attach event listeners to all course deep links*/
    $('.courseLink').on('click', function (e) {
        copyToClipboard(e.target.dataset.course);
    })

    function copyToClipboard(text) {
        console.log(text);
        if (window.clipboardData && window.clipboardData.setData) {
            // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
            return window.clipboardData.setData("Text", text);

        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            }
            catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            }
            finally {
                document.body.removeChild(textarea);
                gsap.fromTo('.copySuccessMessage', { opacity: 0 }, { opacity: 1 })
                gsap.to('.copySuccessMessage', {opacity:0, delay: 3})
            }
        }
    }
}

initComponentsCollapseCardURLOpener();